var idFromName = function idFromName(name) {
  return name.replace(/\]/g, '').replace(/[^-a-zA-Z0-9:.]/g, '_');
};

export { idFromName };
//# sourceMappingURL=html.js.map
